import VueCharts from 'vue-chartjs'
export default {
    extends: VueCharts.Bar,
    data: () => ({
        labels: [],
        open: [],
        closed: [],
        visit10Days: []
    }),
    mounted() {
        var self = this
        self.$ajax.get('/ENROLLMENT_TRANSACTION/GetTransactionsStatusAsync').then(response => {

            for (var i = 0; i < response.data.length; i++) {
                self.labels.push(response.data[i].REGION_NAME)
                self.open.push(response.data[i].ABIERTA)
                self.closed.push(response.data[i].CERRADA)
                self.visit10Days.push(response.data[i].VISITA_10_DIAS)
            }

            self.renderChart({
                labels: self.labels,
                datasets: [
                    {
                        label: 'Cerradas',
                        backgroundColor: '#e6b400',
                        data: self.closed
                    },
                    {
                        label: 'Visita En 10 Días',
                        backgroundColor: '#dce775',
                        data: self.visit10Days
                    },
                    {
                        label: 'Abiertas',
                        backgroundColor: '#e65a3b',
                        data: self.open
                    }
                ]
            }, {
                    scales: {
                        xAxes: [{
                            stacked: true
                        }],
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            },
                            stacked: true
                        }]
                    },
                    responsive: true,
                    responsiveAnimationDuration: 1000,
                    maintainAspectRatio: false
                })
        }).catch(response => {
            self.$root.$snackbar('Ha ocurrido un error mientras se trataba de cargar los datos.', { color: 'error' })
        })
    }
}


// WEBPACK FOOTER //
// ./src/components/monitoria/reportes/statusTransacciones.js